export default __webpack_public_path__ + "f2add7fea9129577218796e11b9dc352.png";